/*                                                                                              
                                      bbbbbbbb                                                                                                    
        CCCCCCCCCCCCC                 b::::::b                              PPPPPPPPPPPPPPPPP                                                     
     CCC::::::::::::C                 b::::::b                              P::::::::::::::::P                                                    
   CC:::::::::::::::C                 b::::::b                              P::::::PPPPPP:::::P                                                   
  C:::::CCCCCCCC::::C                  b:::::b                              PP:::::P     P:::::P                                                  
 C:::::C       CCCCCCuuuuuu    uuuuuu  b:::::bbbbbbbbb        eeeeeeeeeeee    P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
C:::::C              u::::u    u::::u  b::::::::::::::bb    ee::::::::::::ee  P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
C:::::C              u::::u    u::::u  b::::::::::::::::b  e::::::eeeee:::::eeP::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
C:::::C              u::::u    u::::u  b:::::bbbbb:::::::be::::::e     e:::::eP:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
C:::::C              u::::u    u::::u  b:::::b    b::::::be:::::::eeeee::::::eP::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
C:::::C              u::::u    u::::u  b:::::b     b:::::be:::::::::::::::::e P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
C:::::C              u::::u    u::::u  b:::::b     b:::::be::::::eeeeeeeeeee  P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
 C:::::C       CCCCCCu:::::uuuu:::::u  b:::::b     b:::::be:::::::e           P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
  C:::::CCCCCCCC::::Cu:::::::::::::::uub:::::bbbbbb::::::be::::::::e        PP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
   CC:::::::::::::::C u:::::::::::::::ub::::::::::::::::b  e::::::::eeeeeeeeP::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
     CCC::::::::::::C  uu::::::::uu:::ub:::::::::::::::b    ee:::::::::::::eP::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
        CCCCCCCCCCCCC    uuuuuuuu  uuuubbbbbbbbbbbbbbbb       eeeeeeeeeeeeeePPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
*/

const Panorama = require('./Panorama').default
import { originCacheBuster, fireEvent } from './PanoPlayer'
import { types } from './constants'

export default function CubePanorama() {
    Panorama.apply(this, arguments)

    this.rootType = types.CUBE

    this.sidesToLoad = 6

    this.createCubeMesh = function() {
        var _this = this,
            size = this.player.viewerWidth * 4,
            faces = 10,
            cube = new THREE.CubeGeometry(size, size, size, faces, faces, faces)

        var materials = []

        if (this.player.zoom > 1) {
            this.createLqMesh()
        }

        for (var i = 0; i < 6; i++) {
            materials[i] = new THREE.MeshBasicMaterial({
                map: new THREE.TextureLoader().load(this.getTileUrl(i, undefined, this), function() {
                    _this.loadedImage()
                }),
                side: THREE.BackSide,
            })

            for (var pos = i * faces * faces * 2, face = 0; face < faces * faces * 2; pos++, face++) {
                cube.faces[pos].materialIndex = i
            }
        }

        var mesh = new THREE.Mesh(cube, materials)
        // mesh.receiveShadow = true;
        mesh.scale.x = -1 //avoid mirrored images
        mesh.rotation.y = Math.PI //point to center of source image in equirect (UV map puts center 90 deg to left)
        mesh.visible = false //dont show until images loaded

        this.meshes.push(mesh)
    }

    this.createBusinessCard = function(text) {
        if (!text) {
            return
        }

        var width = 420,
            height = 170,
            canvas = document.createElement('canvas'),
            context = canvas.getContext('2d'),
            cTexture = new THREE.Texture(canvas),
            card = new THREE.Mesh(
                new THREE.PlaneGeometry(width, height),
                new THREE.MeshBasicMaterial({
                    map: cTexture,
                    color: 0xffffffff,
                })
            ),
            fontSize = 20

        canvas.width = width
        canvas.height = height

        context.fillStyle = 'rgba(255,255,255,0.7)'
        context.fillRect(0, 0, canvas.width, canvas.height)
        context.font = fontSize + 'px Arial'
        context.fillStyle = 'rgb(0,0,0)'
        context.textAlign = 'center'

        text = text.split('\n')

        var margin = (height - fontSize * text.length) / (text.length + 1),
            hIndex = margin + 45 //not 100% why this is necessary but otherwise its too near the top

        for (var i in text) {
            context.fillText(text[i], width / 2, hIndex)
            hIndex += fontSize + margin
        }

        cTexture.needsUpdate = true

        card.rotation.x = -Math.PI / 2
        card.position.setY(-500)

        this.meshes.push(card)
    }

    this.createLqMesh = function() {
        var _this = this,
            lqSphere = new THREE.Mesh(
                new THREE.SphereGeometry(this.player.viewerWidth * 4, 64, 32),
                new THREE.MeshBasicMaterial({
                    map: new THREE.TextureLoader().load(this.getTileUrl(null, 0, this), function() {
                        fireEvent('viewReady', _this.player)
                        _this.needsRefresh = true
                    }),
                    overdraw: true,
                    transparent: true,
                    side: THREE.BackSide,
                })
            )
        lqSphere.scale.x = -1

        this.lqSphereIndex = this.meshes.length
        this.meshes.push(lqSphere)
    }

    this.loadedImage = function() {
        this.sidesToLoad -= 1

        this.needsRefresh = true

        if (!this.sidesToLoad) {
            // console.log('CALLED+++++', this.meshes)
            // if (typeof this.lqSphereIndex != 'undefined' && this.lqSphereIndex in this.meshes && !this.destroying) {
            //     this.scene.remove(this.meshes[this.lqSphereIndex])
            //     var mesh = this.meshes.splice(this.lqSphereIndex, 1)[0]

            //     mesh.material.map.dispose()
            // }

            for (var i in this.meshes) {
                this.meshes[i].visible = true
            }

            if (!this.player.viewReadyFired) {
                fireEvent('viewReady', this.player)
            }
            fireEvent('panoLoaded', this.player)
        }
    }

    this.regenerateTextures = function() {
        var _this = this

        for (var mI in this.meshes) {
            this.meshes[mI].visible = false
        }

        this.sidesToLoad = 6

        this.createLqMesh()

        this.scene.add(this.meshes[this.lqSphereIndex])

        for (var mI in this.meshes) {
            for (var i in this.meshes[mI].material) {
                this.meshes[mI].material[i].map = new THREE.TextureLoader().load(this.getTileUrl(i), function() {
                    _this.loadedImage()
                })
            }
        }
    }

    // Refactor non-Pano destroy methodology to util function of pano instance
    // this.destroy = function() {
    //     this.destroying = true
    //     Panorama.destroy.call(this)

    //     // we need to free texture image resources to prevent memory leaking
    //     for (var i = 0; i < this.meshes.length; i++) {
    //         var mesh = this.meshes[i]

    //         // if the material is a basic material, it will only have one material to clean up
    //         if (mesh.material.type == 'MeshBasicMaterial') {
    //             mesh.material.map.dispose()

    //             // otherwise, clean em all up
    //         } else {
    //             for (var m = 0; m < mesh.material.length; m++) {
    //                 var mat = mesh.material[m]

    //                 //this.renderer.deallocateTexture(mat.map);
    //                 mat.map.dispose()
    //             } //next m
    //         } //endif
    //     } //next i
    // }

    this._getTileUrl = function(path, size, coord) {
        if (size == 512) {
            return originCacheBuster(path + size + '.jpg')
        }

        if (coord !== undefined && coord !== null) {
            return originCacheBuster(path + 'cube/' + size + '_' + coord + '.jpg')
        } else {
            var urls = [],
                i = 0
            for (i; i < 6; i++) {
                urls.push(originCacheBuster(path + 'cube/' + size + '_' + i + '.jpg'))
            }
            return urls
        }
    }

    this.createCubeMesh()

    this.createBusinessCard(this.player.options.businessCard)
}
